import React from "react";
import {
  VERIFICATION_STATUS,
  LIFECYCLE_STATUS,
} from "../../constants/agentTenderChoices";

// Lifecycle + verification status for the agent's OWN tenders list.
// Kept separate from ClubVerifiedBadge (feed trust axis) on purpose: here we
// combine lifecycle (active/deal/expired) with the verification state so the
// agent sees the full picture of their own tender at a glance.
// Artboard palette (design doc 03, screen 7): bordered tinted pills.
const CONFIG = {
  [VERIFICATION_STATUS.CLUB_VERIFIED]: {
    label: "Club Verified",
    className: "bg-[#ECFDF5] text-[#047857] border-[#A7F3D0]",
    tooltip:
      "This club has confirmed this need and this agent as its channel on the platform.",
  },
  [VERIFICATION_STATUS.UNVERIFIED]: {
    label: "Unverified",
    className: "bg-[#F8FAFC] text-[#64748B] border-[#E2E8F0]",
    tooltip: "Not yet confirmed by the club.",
  },
  [VERIFICATION_STATUS.SUPERSEDED]: {
    label: "Superseded",
    className: "bg-[#FFFBEB] text-[#B45309] border-[#FDE68A]",
    tooltip: "Another request for the same need was club-verified.",
  },
  [LIFECYCLE_STATUS.EXPIRED]: {
    label: "Expired",
    className: "bg-[#F1F5F9] text-[#475569] border-[#E2E8F0]",
    tooltip: "This request is no longer active.",
  },
  // Not drawn in the handoff (artboard silent) — platform styling kept.
  [LIFECYCLE_STATUS.DEAL]: {
    label: "Deal",
    className: "bg-blue-500 text-white border-transparent",
    tooltip: "This request reached a completed deal.",
  },
};

// Precedence: a completed deal wins, then expiry, then the verification state.
const resolveKey = (status, verificationStatus) => {
  if (status === LIFECYCLE_STATUS.DEAL) return LIFECYCLE_STATUS.DEAL;
  if (status === LIFECYCLE_STATUS.EXPIRED) return LIFECYCLE_STATUS.EXPIRED;
  return verificationStatus || VERIFICATION_STATUS.UNVERIFIED;
};

const AgentTenderStatusPill = ({ status, verificationStatus, className = "" }) => {
  const key = resolveKey(status, verificationStatus);
  const cfg = CONFIG[key] || CONFIG[VERIFICATION_STATUS.UNVERIFIED];
  return (
    <span
      title={cfg.tooltip}
      className={`inline-flex items-center px-[9px] py-[3px] rounded-full text-[10.5px] font-bold border ${cfg.className} ${className}`}
    >
      {cfg.label}
    </span>
  );
};

export default AgentTenderStatusPill;
